<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-02 15:49:14
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-30 16:25:43
-->
<template>
  <div class="app-container">
    <el-alert
      v-if="!showTopTips"
      class="top-tips"
      title="当前机构状态已被禁用，无法展示机构和相关产品信息。但仍可以进行部分页面操作。详情请联系管理员"
      type="warning"
      show-icon
      :closable="false"
    >
    </el-alert>
    <div class="header">
      <div class="header-search">
        <el-form :inline="true" :model="ruleForm">
          <el-form-item label="">
            <el-input
              v-model="ruleForm.key"
              :placeholder="placeholderText"
              @keyup.enter.native="getSearch"
              clearable
              @clear="getSearch"
            >
              <i
                @click="getSearch"
                slot="suffix"
                class="el-input__icon el-icon-search"
              ></i
            ></el-input>
          </el-form-item>
          <el-form-item label="上架状态">
            <el-select
              v-model="ruleForm.status"
              placeholder="请选择"
              @change="changeStatus"
              clearable
            >
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker
              v-model="ruleForm.createTime"
              type="daterange"
              @change="changeTime"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="header-footer">
        <div class="typeBox">
          <div class="common-state">
            审核状态：<span
              v-for="(item, index) in auditStatusList"
              :key="index"
              :class="{ 'common-state-active': stateSelected == index }"
              class="common-state-span"
              @click="changeState(index, item)"
              >{{ item.label }} {{ item.num }}</span
            >
          </div>
        </div>
        <div class="addPru" @click="add">新增商品</div>
      </div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{ background: '#fafafa' }"
      height="500"
    >
      <el-table-column
        prop="goodsName"
        label="商品名称"
        width="300"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="是否可用券" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>
            {{ isUseCoupon(scope.row.useCoupon) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="goodsTypeName"
        label="商品类型"
        align="center"
      ></el-table-column>
      <el-table-column label="价格（元）" align="center">
        <template slot-scope="scope">
          <div>
            {{ priceType(scope.row) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="上架状态" align="center">
        <template slot-scope="scope">
          <div>
            {{ statusList[scope.row.status].label }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="审核状态" align="center">
        <template slot-scope="scope">
          <div>
            <span
              :style="{
                background: auditStatusList[scope.row.auditStatus].bgColor
              }"
              style="
                width: 8px;
                height: 8px;
                display: inline-block;
                border-radius: 50%;
              "
            ></span>
            {{ auditStatusList[scope.row.auditStatus].label }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        align="center"
        label="创建时间"
      ></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <span
            v-if="scope.row.status === 1 && scope.row.auditStatus !== 2"
            style="margin-right: 10px; color: #1890ff; cursor: pointer"
            @click="
              operate(
                scope.row.id,
                2,
                '上架商品需要审核，是否继续?',
                '操作成功'
              )
            "
            >上架</span
          >
          <span
            v-if="scope.row.status === 2"
            style="margin-right: 10px; color: #1890ff; cursor: pointer"
            @click="operate(scope.row.id, 1, '是否要下架?', '下架成功')"
            >下架</span
          >
          <span
            style="margin-right: 10px; color: #1890ff; cursor: pointer"
            @click="viewDetail(scope.row.id)"
            >查看</span
          >
          <span
            style="margin-right: 10px; color: #1890ff; cursor: pointer"
            @click="edit(scope.row.id, scope.row.status)"
            >修改</span
          >
          <span
            style="margin-right: 10px; color: #1890ff; cursor: pointer"
            @click="operate(scope.row.id, 0, '是否确认删除？', '删除成功')"
            >删除</span
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="table-page">
      <el-pagination
        background
        layout="total,prev, pager, next, sizes, jumper"
        :current-page.sync="pageNum"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        :total="totalRecord"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { checkStatus } from '@api/yardIntermediary/applicationResidency'
import {
  listByPage,
  statusCount,
  operateGoods
} from '@api/yardIntermediary/commodityManagement-ent'
export default {
  data() {
    return {
      ruleForm: {
        key: '', // 视频名称
        startDate: '',
        endDate: '',
        pageNum: '', // 发起人类型
        pageSize: '', // 走访状态
        status: '',
        auditStatus: ''
      },
      statusList: [
        { value: '', label: '全部' },
        { value: 1, label: '未上架' },
        { value: 2, label: '已上架' }
      ], // 所有类别数据
      auditStatusList: [
        { value: '', label: '全部' },
        {
          num: '',
          field: 'notSubmitAudit',
          value: 1,
          label: '未提交审核',
          bgColor: 'rgba(0, 119, 255,0.9)'
        },
        {
          num: '',
          field: 'waitAudit',
          value: 2,
          label: '待审核',
          bgColor: 'rgba(0, 119, 255,0.9)'
        },
        {
          num: '',
          field: 'passAudit',
          value: 3,
          label: '审核通过',
          bgColor: 'rgb(73, 194, 105)'
        },
        {
          num: '',
          field: 'rejectAudit',
          value: 4,
          label: '审核驳回',
          bgColor: 'rgb(251, 76, 76)'
        }
      ],
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      totalRecord: 0,
      roleText: '',
      placeholderText: '请输入商品名称',
      stateSelected: 0,
      showTopTips: true
    }
  },
  watch: {},
  computed: {
    isUseCoupon() {
      return (number) => {
        let val
        switch (number) {
          case 0:
            val = '否'
            break
          case 1:
            val = '是'
            break
        }
        return val
      }
    }
  },
  mounted() {
    this.getStatus()
    this.statusCountList()
    this.listGoodsData()
  },
  methods: {
    // 获取该机构启用状态
    getStatus() {
      this.roleText = this.$store.state.user.userInfo.roleText
      const organizationType = this.roleText == '机构' ? 1 : 2
      checkStatus({ organizationType }).then((res) => {
        if (res.data.code == '0000') {
          const data = res.data.data[0] || {}
          this.showTopTips = data.isOpen == 1
        }
      })
    },
    priceType(item) {
      return item.priceType === 1 ? '面议' : item.price
    },
    changeStatus(data) {
      this.listGoodsData()
    },
    // 商品名称搜索
    getSearch() {
      this.pageNum = 1
      this.listGoodsData()
    },

    changeTime(data) {
      this.currentPage = 1
      if (data) {
        this.ruleForm.startDate = data[0]
        this.ruleForm.endDate = data[1]
      } else {
        this.ruleForm.startDate = ''
        this.ruleForm.endDate = ''
      }
      this.listGoodsData()
    },
    //  表格翻页
    handleCurrentChange(pageNum, e) {
      this.pageNum = pageNum
      this.listGoodsData()
    },
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.listGoodsData()
    },
    viewDetail(id) {
      this.$router.push({
        name: 'productDetail',
        query: { id: id, type: 'ent' }
      })
    },
    // 新增
    add() {
      this.$router.push({ name: 'addProduct', query: { type: 'add', organizationType: this.roleText == '机构' ? 1 : 2 } })
    },
    edit(id, status) {
      if (status === 2) {
        this.$message.error({
          type: 'error',
          message: '请先下架商品再修改信息'
        })
        return
      }
      this.$router.push({
        name: 'addProduct',
        query: { id: id, type: 'edit' }
      })
    },
    // 状态统计
    statusCountList() {
      statusCount().then((res) => {
        if (res.data.code == '0000') {
          console.log(res)
          this.auditStatusList.map((d, index) => {
            if (d.label !== '全部') {
              d.num = res.data.data[d.field] ? res.data.data[d.field] : 0
            }
          })
        }
      })
    },
    // 列表
    listGoodsData() {
      let par = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        key: this.ruleForm.key,
        startDate: this.ruleForm.startDate,
        endDate: this.ruleForm.endDate,
        auditStatus: this.ruleForm.auditStatus,
        status: this.ruleForm.status
      }
      listByPage(par).then((res) => {
        if (res.data.code == '0000') {
          const data = res.data.data
          this.tableData = data.list || []
          this.totalRecord = data.total || 0
        }
      })
    },
    // 操作列表
    operate(id, status, tipMsg, msg) {
      this.$confirm(tipMsg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.operateSure(id, status, msg)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    operateSure(id, status, msg) {
      operateGoods({ id, status }).then((res) => {
        if (res.data.code == '0000') {
          this.$message({
            type: 'success',
            message: msg
          })

          // 刪除 翻页到另一页只有一条删除成功，需展示前一页数据
          if (status === 0 && this.tableData.length === 1) {
            this.pageNum = this.pageNum != 1 ? this.pageNum - 1 : 1
          }
          this.listGoodsData()
          this.statusCountList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 改变审核状态选项
    changeState(index, d) {
      this.pageNum = 1
      this.stateSelected = index
      this.ruleForm.auditStatus = d.value
      this.listGoodsData()
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-range-separator {
  width: 8% !important;
}
$color-primary: rgba(51, 153, 255, 1);
// 状态公共样式
.common-state {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  height: 32px;
  line-height: 32px;
  white-space: nowrap;
  &-span {
    color: rgba(0, 0, 0, 0.45);
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 0.344rem 1rem;
    cursor: pointer;
    margin-right: -1px;
    z-index: 1;
    transition: 0.2s all;

    &:hover {
      background: $color-primary;
      border: 1px solid $color-primary;
      color: #fff;
      z-index: 2;
    }

    &:first-of-type {
      border-radius: 4px 0 0 4px;
      z-index: 2;
    }

    &:last-of-type {
      border-radius: 0 4px 4px 0;
      z-index: 2;
    }
  }

  &-active {
    background: $color-primary;
    border: 1px solid $color-primary;
    color: #fff;
    z-index: 2;
  }
}
.top-tips {
  margin-bottom: 10px;
  background-color: #ffeded;
  color: #ff4949;
}
.header {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  &-search {
    display: flex;
    .el-input {
      width: 300px;
      margin-right: 30px;
    }
  }
  &-footer {
    display: flex;
    justify-content: space-between;
  }
  .addPru {
    width: 100px;
    display: inline-block;
    text-align: center;
    height: 36px;
    border-radius: 5px;
    line-height: 36px;
    background: #1890ff;
    color: #fff;
    cursor: pointer;
    font-size: 16px;
  }
}
.actcolor {
  color: #1890ff;
}
.nocolor {
  color: rgba(0, 0, 0, 0.3);
}
.changeAppeal {
  cursor: pointer;
  color: #1890ff;
}
.el-table::before {
  height: 0px;
}
.table-page {
  width: 100%;
  text-align: center;
  margin-top: 24px;
  margin-bottom: 20px;
}
.sharing-code {
  display: flex;
  span {
    line-height: 34px;
  }
  /deep/.el-input__inner {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  /deep/.el-button--medium {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
}
.exhibition {
  // margin-top: 20px;
  margin-left: -25px;
  display: flex;
  #qrcode {
    width: 125px;
    height: 150px;
    margin: 20px auto;
  }
  .refreshs {
    margin: 20px auto;
    span {
      margin-left: 22px;
    }
    .refresh {
      margin-left: 50px;
      cursor: pointer;
    }
  }
}
</style>
<style lang="scss">
.el-tooltip__popper {
  max-width: 300px;
}
.el-popover {
  min-width: 100px !important;
}
</style>
